
import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from '../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';


@Injectable()
export class ApiSleepSensorService extends ApiBaseService {

  protected headers: Headers;
  protected apiName = '[ ApiSleepSensorService ]';
  isLoading: boolean = true;
  // sensorList = [
  //   // シミュレーターで利用している情報
  //   {
  //     sensorId: '5ddb7cc79206e4dae177635c',
  //     makerCode:'PARAMOUNTBED', makerName: 'パラマウントベッド', productCode:'nemuriSCAN', productName: '眠りSCAN',
  //     serialId: 'TEST_0001', macAddress:'', memo: '', isSyncEnabled : true,
  //     patientId: '', roomId: ''
  //   },
  //   //
  //   {
  //     sensorId: '5ddd633c9206e4dae1785a80',
  //     makerCode:'FRANCEBED', makerName: 'フランスベッド', productCode:'M-2', productName: 'M-2',
  //     serialId: 'TEST_0001', macAddress:'', memo: '', isSyncEnabled : true,
  //     patientId: '', roomId: ''
  //   },

  //   {
  //     sensorId: '5ddd63539206e4dae1785a91',
  //     makerCode:'BIOSILVER', makerName: 'バイオシルバー', productCode:'aams', productName: 'aams',
  //     serialId: 'TEST_0001', macAddress:'', memo: '', isSyncEnabled : true,
  //     patientId: '', roomId: ''
  //   },
  // ];

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }
  /**
   * スタッフ一覧取得API
   * @return void
   */
  list(): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + '/api/v1/sensor/devices',
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }
  async getSettingInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doGet({
        url: this.apiAuthStore.url + `/api/v1/sensor/settingInfo`,
        headers: this.headers,
      }).subscribe(
        (response) => resolve(response),
        (err) => reject(err)
      );
    })
  }

  /**
   * センサーの登録
   * @param params
   */
  async create(params): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/sensor/device`,
        body: params, headers: this.headers
      }).subscribe(response => resolve(response), err => reject(err))
    })
  }

  /**
   * センサー情報の更新
   * @param params
   */
  async update(params): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doPut({
        url: this.apiAuthStore.url + `/api/v1/sensor/device/${params._id}`,
        body: params.body,
        headers: this.headers
      }).subscribe(response => resolve(response), err => reject(err))
    })
  }

  /**
   * センサー情報の全更新
   * @param params
   */
  async updateAll(params): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doPut({
        url: this.apiAuthStore.url + `/api/v1/sensor/devices`,
        body: params.body,
        headers: this.headers
      }).subscribe(response => resolve(response), err => reject(err))
    })
  }

  /**
   * センサーの削除
   * @param params
   */
  async delete(params): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doDelete({
        url: this.apiAuthStore.url + `/api/v1/sensor/device/${params._id}`,
        headers: this.headers
      }).subscribe(response => resolve(response), err => reject(err))
    })
  }


}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-sleep-sensor.service.ts